import { useEffect } from 'react';
import { useI18n } from '../i18n';
import { useSession } from '../hooks/useSession';
import {
  resolveLegalHref,
  setLegalFailedMessage,
  useLegalPending,
  useReconsentForm,
} from '../hooks/useLegal';
import { ReconsentSheet } from '../components/Legal';

/**
 * W21 reconsent: when a document was republished as a material change, signed-in customers see
 * a blocking accept sheet until they accept it. Nothing shows while the legal store is off.
 */
export function LegalGate() {
  const { t } = useI18n();
  const session = useSession();
  const legal = useLegalPending(session.signedIn);
  const form = useReconsentForm(legal.pending.map((doc) => doc.documentId));

  useEffect(() => {
    setLegalFailedMessage(t('legal.acceptFailed'));
  }, [t]);

  if (!session.signedIn || legal.pending.length === 0) return null;
  return (
    <ReconsentSheet
      docs={legal.pending}
      open={form.open}
      agreed={form.agreed}
      accepting={legal.accepting}
      resolveHref={resolveLegalHref}
      onToggle={form.toggle}
      onAgree={form.setAgreed}
      onAccept={() => legal.accept(legal.pending.map((doc) => doc.documentId))}
      onSignOut={session.signOut}
      labels={{
        title: t('legal.reconsentTitle'),
        body: t('legal.reconsentBody'),
        whatChanged: t('legal.whatChanged'),
        version: (version) => t('legal.version', { version }),
        read: t('legal.read'),
        hide: t('legal.hide'),
        agree: t('legal.agree'),
        accept: t('legal.accept'),
        signOut: t('legal.signOut'),
      }}
    />
  );
}
